// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MenuIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MenuIcon" ref={forwardedRef} {...props}>
      <path d="M3 4.25h14v1.5H3z" />
      <path d="M3 9.25h14v1.5H3z" />
      <path d="M17 14.25H3v1.5h14z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MenuIcon = /* @__PURE__ */ Object.assign(MenuIconComponent, {
  displayName: 'MenuIcon',
});
